import * as THREE from 'three'
import TimeManager from '../Utils/TimeManager'
import LineCube from './NodeLayer/Models/Cubes/LineCube'
import waterVertexShader from '../../Shaders/Water/vertex.glsl'
import waterFragmentShader from '../../Shaders/Water/fragment.glsl'

export default class STLayer
{
    constructor(scene) {
        this.scene = scene

        this.time = new TimeManager()

        this.line = null

        // subscribe to update
        this.scene.time.on('tick', () =>
        {
            this.update()
        })

        this.createLayer()
        
    }

    createLayer() {

        this.holeSide = this.scene.STside

        this.holeHeight = 4

        this.createHole()

        this.createWater()

        const planeSize = 10
        const planeShift = (planeSize + this.holeSide)/2

        //these are the 4 black planes that simulate the "ground"
        const planeGeom = new THREE.PlaneGeometry(planeSize, planeSize)
        const planeMat = new THREE.MeshBasicMaterial( {color: "black"} );
        planeMat.side = THREE.DoubleSide
        planeMat.fog = false
        const planeUL = new THREE.Mesh(planeGeom, planeMat)
        const planeUR = new THREE.Mesh(planeGeom, planeMat)
        const planeDR = new THREE.Mesh(planeGeom, planeMat)
        const planeDL = new THREE.Mesh(planeGeom, planeMat)
        this.scene.add(planeUL)
        this.scene.add(planeUR)
        this.scene.add(planeDR)
        this.scene.add(planeDL)
        planeUL.position.set(planeShift,0,0)
        planeUR.position.set(0,0,planeShift)
        planeDR.position.set(-planeShift,0,0)
        planeDL.position.set(0,0,-planeShift)
        planeUL.rotateX(-Math.PI/2)
        planeUR.rotateX(-Math.PI/2)
        planeDR.rotateX(-Math.PI/2)
        planeDL.rotateX(-Math.PI/2)
    }

    createWater() {
        this.waters = []
            const waterMaterial = new THREE.ShaderMaterial({
                vertexShader: waterVertexShader,
                fragmentShader: waterFragmentShader,
                blending: THREE.NormalBlending,
                wireframe: false,
                transparent: true,
                depthWrite: false,
                uniforms:
                {
                    uTime: { value: 0 },
                    uOffset: { value: 0 },
                    uAngleX: { value: 0 },
                    uAngleY: { value: 0 },
                    
                    uBigWavesElevation: { value: 0.05 },
                    uBigWavesFrequency: { value: new THREE.Vector2(2, 6) },
                    uBigWavesSpeed: { value: 0.8},
            
                    uSmallWavesElevation: { value: 0.6 },
                    uSmallWavesFrequency: { value: 3 },
                    uSmallWavesSpeed: { value: 0.3 },
                    uSmallIterations: { value: 2 },
            
                    uDepthColor: { value: new THREE.Color('#963dae') },
                    uSurfaceColor: { value: new THREE.Color('cyan') },
                    uColorOffset: { value: 0 },
                    uColorMultiplier: { value: 0.45 },

                    uMinimumAlpha: { value: 0.0 },
                    uAlphaElevationFactor: { value: 3.0 }
                }
            })
            const waterGeometry = new THREE.PlaneGeometry(this.holeSide, this.holeSide, 80, 130)

            const water = new THREE.Mesh(waterGeometry, waterMaterial)
            this.scene.add(water)
            water.rotateX(-Math.PI*0.5)
            water.translateZ(-0.70)
            this.waters.push(water)
    }

    createHole() {
        const textureLoader = new THREE.TextureLoader()
        const matcapTex = textureLoader.load('./textures/models/matcap.png')
        const alphaMapTex = textureLoader.load('./textures/models/matcap-alphamap-ST.png')
        const alphaMapTex2 = textureLoader.load('./textures/models/matcap-alphamap2-ST.png')
        const SXTlogo = textureLoader.load('./textures/SXT database logo.svg')

        const cubeGeom = new THREE.BoxGeometry(this.holeSide,this.holeHeight,this.holeSide,1,1,1)
        const cubeMat = new THREE.MeshMatcapMaterial( {
            color: "#531bd5"
            } );
        const cube = new THREE.Mesh( cubeGeom, cubeMat );
        cubeMat.side = THREE.BackSide
        cubeMat.matcap = matcapTex
        cubeMat.alphaMap = alphaMapTex2
        cubeMat.transparent = true
        this.scene.add( cube );
        cube.translateY(-this.holeHeight/2)

        const cubeGeom2 = new THREE.BoxGeometry(this.holeSide-0.001,this.holeHeight-0.001,this.holeSide-0.001,1,1,1)
        const cubeMat2 = new THREE.MeshMatcapMaterial( {
            color: "#963dae"
            } );
        const cube2 = new THREE.Mesh( cubeGeom2, cubeMat2 );
        cubeMat2.side = THREE.BackSide
        cubeMat2.matcap = matcapTex
        cubeMat2.alphaMap = alphaMapTex
        cubeMat2.transparent = true
        cubeMat2.opacity = 1
        this.scene.add( cube2 );
        cube2.translateY(-this.holeHeight/2)


        const lineCube = new LineCube(this.holeSide)
        this.scene.add( lineCube );
        lineCube.translateY(-this.holeSide*0.5)


        const textDeltaFromReferenceSize = (this.holeSide-1)*0.5
        const spriteGeometry = new THREE.PlaneBufferGeometry(1 * 0.52, 0.04 * 0.52,1)
        const spriteMaterial = new THREE.MeshBasicMaterial( { map: SXTlogo } );
        spriteMaterial.transparent = true

        const sprite = new THREE.Mesh( spriteGeometry, spriteMaterial );
        this.scene.add( sprite );
        sprite.translateZ(0.545+textDeltaFromReferenceSize)
        sprite.translateY(0.001)
        sprite.translateX(-0.239-textDeltaFromReferenceSize)
        sprite.rotateX(-Math.PI*0.5)
    }

    update() {
        for (let index = 0; index < this.waters.length; index++) {
            this.waters[index].material.uniforms.uTime.value = this.time.elapsed*0.0002
            this.waters[index].material.uniforms.uAngleX.value = this.scene.camera.position.x + this.scene.camera.position.z
            this.waters[index].material.uniforms.uAngleY.value = this.scene.camera.position.y
        }
    }
}